import { Component, OnInit, Inject, ChangeDetectionStrategy, ElementRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { ScreenDimensions } from 'src/app/shared/models/screen.dimensions.model';

export enum LegacyDialogEnum {
  UpgradeSubscription = '/legacy/upgrade-human.html',
  BuySubscription = '/legacy/buy-subscription.html',
  MyProfile = '/legacy/user-account.html'
}

export interface LegacyDialogData {
  type: LegacyDialogEnum;
  dimensions: ScreenDimensions;
  options?: any;
}

@Component({
  selector: 'app-legacy-dialog',
  templateUrl: './legacy-dialog.component.html',
  styleUrls: ['./legacy-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LegacyDialogComponent implements OnInit {

  headerOffset = 100;

  settings: LegacyDialogData = {
    type: null,
    dimensions: {
      width: 100,
      height: 100
    }
  };

  get height(): number {
    const { height } = this.settings.dimensions;
    const targetHeight = height - this.headerOffset;
    return Math.max(200, targetHeight);
  }

  get src(): SafeResourceUrl {
    const url = this.getURL();
    if (url) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    } else {
      return null;
    }
  }

  constructor(
    private dialogRef: MatDialogRef<LegacyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: LegacyDialogData,
    private sanitizer: DomSanitizer
  ) {
    this.settings = {
      ...this.settings,
      ...data
    };
    const { width, height} = data.dimensions;
    // size modal
    this.dialogRef.updateSize(`${width}px`, `${height}px`);
  }

  ngOnInit() {
    
  }

  closeDialog() {
    this.dialogRef.close();
  }

  // get modal url
  private getURL(): string {
    const url = `${this.settings.type}`;
    const valid = Object.values(LegacyDialogEnum).includes(url);
    if (valid) {
      const urlParams = this.getURLParams();
      if (urlParams) {
        return `${url}?${urlParams}`;
      } else {
        return url;
      }
    } else {
      return '';
    }
  }

  // get optional url params
  private getURLParams(): string {
    const options = this.settings.options;
    if (options) {
      return Object.entries(options)
        .map(([key, value]) => {
          return `${key}=${value}`;
        })
        .join('&');
    } else {
      return '';
    }
  }
}
